export default __webpack_public_path__ + "static/media/480_dummy2016-fotograf02-mobile-de.2a91957b.png";